module.exports = __webpack_public_path__ + "img/price-rounded.73eac2e7.svg";